import { Flex, Text } from "onefaceui-react-components";
import React, { memo, useCallback } from "react";
import PropTypes from 'prop-types';

import { renderTransportInfo } from "react/utils/utils";

const HolderMaterials = ({
  holdMatArray,
  i18n
}) => {
  const getOrderedUnits = useCallback((sku) => [sku?.size1Alias, sku?.size2Alias, sku?.size3Alias].filter(Boolean), []);

  const getSizeQuantity = useCallback((sku, size) => {
    const sizeQuantity = sku[`size${size}Quantity`];

    return sizeQuantity ?? 0;
  }, []);

  return (
    <div>
      <div className="qtySkuStrings">
        <div>{i18n.getResourcesByKey("route.data.quantity")}</div>
        <div>{i18n.getResourcesByKey("Sku")}</div>
      </div>
      <div id="materialGrid">
        {holdMatArray.map((item) =>
          <React.Fragment key={`quantity_${item.id}`}>
            <div className="itemContainer">
              <div className="quantity">{item.size1Quantity}</div>
              <Flex flexDirection="column" alignItems="center" gap={8}>
                {getOrderedUnits(item).map(unit => (
                  <span key={unit.icon} className={`box ${unit.icon}`} />
                ))}
              </Flex>
            </div>
            <div className="skuContainer">
              <div className="skuKey">{item.sku.key}</div>
              <div className="transportInfos">
                <div>{item.sku.description}</div>
                {renderTransportInfo(item.transport)}
                <div className="boxQty">
                  <Flex
                    gap={2}
                    flexDirection="column"
                  >
                    {getOrderedUnits(item).map((unit) => (
                      <Flex gap={4} key={unit.description} alignunits="center">
                        <Text size="xs" weight="bold">{getSizeQuantity(item, unit.preferredSize)}</Text>
                        <Text size="xs">{unit.description}</Text>
                      </Flex>
                    ))}
                  </Flex>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

HolderMaterials.propTypes = {
  holdMatArray: PropTypes.array.isRequired,
  i18n: PropTypes.object.isRequired
};

export default memo(HolderMaterials);
